export const postWebviewMessage = (event, data) =>
  window.ReactNativeWebView?.postMessage(JSON.stringify({event, data}))
